export default __webpack_public_path__ + "static/gf-0ae8211fd67c4baa31f0c632b0198acf.svg";